import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import BrowserPersistence from '../../../util/simplePersistence';
import { signOut } from '../user';
import actions from './actions';
var storage = new BrowserPersistence();
export var createCart = function createCart(payload) {
  return /*#__PURE__*/function () {
    var _thunk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var fetchCartId, _getState, cart, cartId, _yield$fetchCartId, data, errors, receivePayload;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              fetchCartId = payload.fetchCartId;
              _getState = getState(), cart = _getState.cart; // if a cart already exists in the store, exit

              if (!cart.cartId) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return");

            case 4:
              // Request a new cart.
              dispatch(actions.getCart.request()); // if a cart exists in storage, act like we just received it

              _context.next = 7;
              return retrieveCartId();

            case 7:
              cartId = _context.sent;

              if (!cartId) {
                _context.next = 11;
                break;
              }

              dispatch(actions.getCart.receive(cartId));
              return _context.abrupt("return");

            case 11:
              _context.prev = 11;
              _context.next = 14;
              return fetchCartId({
                fetchPolicy: 'no-cache'
              });

            case 14:
              _yield$fetchCartId = _context.sent;
              data = _yield$fetchCartId.data;
              errors = _yield$fetchCartId.errors;

              if (errors) {
                receivePayload = new Error(errors);
              } else {
                receivePayload = data.cartId; // write to storage in the background

                saveCartId(data.cartId);
              }

              dispatch(actions.getCart.receive(receivePayload));
              _context.next = 25;
              break;

            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](11);
              // If we are unable to create a cart, the cart can't function, so
              // we forcibly throw so the upstream actions won't retry.
              dispatch(actions.getCart.receive(_context.t0));
              throw new Error('Unable to create cart');

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[11, 21]]);
    }));

    function thunk(_x, _x2) {
      return _thunk.apply(this, arguments);
    }

    return thunk;
  }();
};
export var addItemToCart = function addItemToCart() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var addItemMutation = payload.addItemMutation,
      fetchCartDetails = payload.fetchCartDetails,
      fetchCartId = payload.fetchCartId,
      item = payload.item,
      quantity = payload.quantity,
      parentSku = payload.parentSku;
  var writingImageToCache = writeImageToCache(item);
  return /*#__PURE__*/function () {
    var _thunk2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var _getState2,
          cart,
          user,
          cartId,
          isSignedIn,
          variables,
          shouldRetry,
          _args2 = arguments;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return writingImageToCache;

            case 2:
              dispatch(actions.addItem.request(payload));
              _getState2 = getState(), cart = _getState2.cart, user = _getState2.user;
              cartId = cart.cartId;
              isSignedIn = user.isSignedIn;
              _context2.prev = 6;
              variables = {
                cartId: cartId,
                parentSku: parentSku,
                product: item,
                quantity: quantity,
                sku: item.sku
              };
              _context2.next = 10;
              return addItemMutation({
                variables: variables
              });

            case 10:
              _context2.next = 12;
              return dispatch(getCartDetails({
                fetchCartId: fetchCartId,
                fetchCartDetails: fetchCartDetails
              }));

            case 12:
              dispatch(actions.addItem.receive());
              _context2.next = 38;
              break;

            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](6);
              dispatch(actions.addItem.receive(_context2.t0));
              shouldRetry = !_context2.t0.networkError && isInvalidCart(_context2.t0); // Only retry if the cart is invalid or the cartId is missing.

              if (!shouldRetry) {
                _context2.next = 38;
                break;
              }

              if (!isSignedIn) {
                _context2.next = 25;
                break;
              }

              _context2.next = 23;
              return dispatch(signOut());

            case 23:
              _context2.next = 27;
              break;

            case 25:
              _context2.next = 27;
              return dispatch(removeCart());

            case 27:
              _context2.prev = 27;
              _context2.next = 30;
              return dispatch(createCart({
                fetchCartId: fetchCartId
              }));

            case 30:
              _context2.next = 35;
              break;

            case 32:
              _context2.prev = 32;
              _context2.t1 = _context2["catch"](27);
              return _context2.abrupt("return");

            case 35:
              _context2.next = 37;
              return dispatch(getCartDetails({
                fetchCartId: fetchCartId,
                fetchCartDetails: fetchCartDetails
              }));

            case 37:
              return _context2.abrupt("return", thunk.apply(void 0, _args2));

            case 38:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[6, 15], [27, 32]]);
    }));

    function thunk(_x3, _x4) {
      return _thunk2.apply(this, arguments);
    }

    return thunk;
  }();
};
/**
 * Applies changes in options/quantity to a cart item.
 *
 * @param payload.cartItemId {Number} the id of the cart item we are updating
 * @param payload.item {Object} the new configuration item if changes are selected.
 * @param payload.quantity {Number} the quantity of the item being updated
 * @param payload.productType {String} 'ConfigurableProduct' or other.
 */

export var updateItemInCart = function updateItemInCart() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cartItemId = payload.cartItemId,
      fetchCartDetails = payload.fetchCartDetails,
      fetchCartId = payload.fetchCartId,
      item = payload.item,
      productType = payload.productType,
      quantity = payload.quantity,
      removeItem = payload.removeItem,
      updateItem = payload.updateItem;
  var writingImageToCache = writeImageToCache(item);
  return /*#__PURE__*/function () {
    var _thunk3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch, getState) {
      var _getState3,
          cart,
          user,
          cartId,
          isSignedIn,
          shouldRetry,
          _args3 = arguments;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return writingImageToCache;

            case 2:
              dispatch(actions.updateItem.request(payload));
              _getState3 = getState(), cart = _getState3.cart, user = _getState3.user;
              cartId = cart.cartId;
              isSignedIn = user.isSignedIn;
              _context3.prev = 6;

              if (!(productType === 'ConfigurableProduct')) {
                _context3.next = 14;
                break;
              }

              _context3.next = 10;
              return dispatch(removeItemFromCart({
                item: {
                  id: cartItemId
                },
                fetchCartDetails: fetchCartDetails,
                fetchCartId: fetchCartId,
                removeItem: removeItem
              }));

            case 10:
              _context3.next = 12;
              return dispatch(addItemToCart(_objectSpread({}, payload)));

            case 12:
              _context3.next = 18;
              break;

            case 14:
              _context3.next = 16;
              return updateItem({
                variables: {
                  cartId: cartId,
                  itemId: cartItemId,
                  quantity: quantity
                }
              });

            case 16:
              _context3.next = 18;
              return dispatch(getCartDetails({
                fetchCartId: fetchCartId,
                fetchCartDetails: fetchCartDetails
              }));

            case 18:
              dispatch(actions.updateItem.receive());
              _context3.next = 44;
              break;

            case 21:
              _context3.prev = 21;
              _context3.t0 = _context3["catch"](6);
              dispatch(actions.updateItem.receive(_context3.t0));
              shouldRetry = !_context3.t0.networkError && isInvalidCart(_context3.t0);

              if (!shouldRetry) {
                _context3.next = 44;
                break;
              }

              _context3.next = 28;
              return dispatch(removeCart());

            case 28:
              _context3.prev = 28;
              _context3.next = 31;
              return dispatch(createCart({
                fetchCartId: fetchCartId
              }));

            case 31:
              _context3.next = 36;
              break;

            case 33:
              _context3.prev = 33;
              _context3.t1 = _context3["catch"](28);
              return _context3.abrupt("return");

            case 36:
              _context3.next = 38;
              return dispatch(getCartDetails({
                fetchCartId: fetchCartId,
                fetchCartDetails: fetchCartDetails
              }));

            case 38:
              if (!isSignedIn) {
                _context3.next = 42;
                break;
              }

              return _context3.abrupt("return", thunk.apply(void 0, _args3));

            case 42:
              _context3.next = 44;
              return dispatch(addItemToCart(_objectSpread({}, payload)));

            case 44:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[6, 21], [28, 33]]);
    }));

    function thunk(_x5, _x6) {
      return _thunk3.apply(this, arguments);
    }

    return thunk;
  }();
};
export var removeItemFromCart = function removeItemFromCart(payload) {
  var item = payload.item,
      fetchCartDetails = payload.fetchCartDetails,
      fetchCartId = payload.fetchCartId,
      removeItem = payload.removeItem;
  return /*#__PURE__*/function () {
    var _thunk4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch, getState) {
      var _getState4, cart, cartId, shouldResetCart;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              dispatch(actions.removeItem.request(payload));
              _getState4 = getState(), cart = _getState4.cart;
              cartId = cart.cartId;
              _context4.prev = 3;
              _context4.next = 6;
              return removeItem({
                variables: {
                  cartId: cartId,
                  itemId: item.uid
                }
              });

            case 6:
              dispatch(actions.removeItem.receive());
              _context4.next = 24;
              break;

            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](3);
              dispatch(actions.removeItem.receive(_context4.t0));
              shouldResetCart = !_context4.t0.networkError && isInvalidCart(_context4.t0);

              if (!shouldResetCart) {
                _context4.next = 24;
                break;
              }

              _context4.next = 16;
              return dispatch(removeCart());

            case 16:
              _context4.prev = 16;
              _context4.next = 19;
              return dispatch(createCart({
                fetchCartId: fetchCartId
              }));

            case 19:
              _context4.next = 24;
              break;

            case 21:
              _context4.prev = 21;
              _context4.t1 = _context4["catch"](16);
              return _context4.abrupt("return");

            case 24:
              _context4.next = 26;
              return dispatch(getCartDetails({
                fetchCartId: fetchCartId,
                fetchCartDetails: fetchCartDetails
              }));

            case 26:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[3, 9], [16, 21]]);
    }));

    function thunk(_x7, _x8) {
      return _thunk4.apply(this, arguments);
    }

    return thunk;
  }();
};
export var getCartDetails = function getCartDetails(payload) {
  var fetchCartId = payload.fetchCartId,
      fetchCartDetails = payload.fetchCartDetails;
  return /*#__PURE__*/function () {
    var _thunk5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch, getState, _ref) {
      var apolloClient,
          _getState5,
          cart,
          user,
          cartId,
          isSignedIn,
          _yield$fetchCartDetai,
          data,
          details,
          shouldResetCart,
          _args5 = arguments;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              apolloClient = _ref.apolloClient;
              _getState5 = getState(), cart = _getState5.cart, user = _getState5.user;
              cartId = cart.cartId;
              isSignedIn = user.isSignedIn; // if there isn't a cart, create one then retry this operation

              if (cartId) {
                _context5.next = 14;
                break;
              }

              _context5.prev = 5;
              _context5.next = 8;
              return dispatch(createCart({
                fetchCartId: fetchCartId
              }));

            case 8:
              _context5.next = 13;
              break;

            case 10:
              _context5.prev = 10;
              _context5.t0 = _context5["catch"](5);
              return _context5.abrupt("return");

            case 13:
              return _context5.abrupt("return", thunk.apply(void 0, _args5));

            case 14:
              // Once we have the cart id indicate that we are starting to make
              // async requests for the details.
              dispatch(actions.getDetails.request(cartId));
              _context5.prev = 15;
              _context5.next = 18;
              return fetchCartDetails({
                variables: {
                  cartId: cartId
                },
                fetchPolicy: 'network-only'
              });

            case 18:
              _yield$fetchCartDetai = _context5.sent;
              data = _yield$fetchCartDetai.data;
              details = data.cart;
              dispatch(actions.getDetails.receive({
                details: details
              }));
              _context5.next = 47;
              break;

            case 24:
              _context5.prev = 24;
              _context5.t1 = _context5["catch"](15);
              dispatch(actions.getDetails.receive(_context5.t1));
              shouldResetCart = !_context5.t1.networkError && isInvalidCart(_context5.t1);

              if (!shouldResetCart) {
                _context5.next = 47;
                break;
              }

              if (!isSignedIn) {
                _context5.next = 34;
                break;
              }

              _context5.next = 32;
              return dispatch(signOut());

            case 32:
              _context5.next = 36;
              break;

            case 34:
              _context5.next = 36;
              return dispatch(removeCart());

            case 36:
              _context5.next = 38;
              return apolloClient.clearCacheData(apolloClient, 'cart');

            case 38:
              _context5.prev = 38;
              _context5.next = 41;
              return dispatch(createCart({
                fetchCartId: fetchCartId
              }));

            case 41:
              _context5.next = 46;
              break;

            case 43:
              _context5.prev = 43;
              _context5.t2 = _context5["catch"](38);
              return _context5.abrupt("return");

            case 46:
              return _context5.abrupt("return", thunk.apply(void 0, _args5));

            case 47:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[5, 10], [15, 24], [38, 43]]);
    }));

    function thunk(_x9, _x10, _x11) {
      return _thunk5.apply(this, arguments);
    }

    return thunk;
  }();
};
export var removeCart = function removeCart() {
  return /*#__PURE__*/function () {
    var _thunk6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(dispatch) {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return clearCartId();

            case 2:
              // Clear the cart info from the redux store.
              dispatch(actions.reset());

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    function thunk(_x12) {
      return _thunk6.apply(this, arguments);
    }

    return thunk;
  }();
};
/* helpers */

export function retrieveCartId() {
  return _retrieveCartId.apply(this, arguments);
}

function _retrieveCartId() {
  _retrieveCartId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", storage.getItem('cartId'));

          case 1:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _retrieveCartId.apply(this, arguments);
}

export function saveCartId(_x13) {
  return _saveCartId.apply(this, arguments);
}

function _saveCartId() {
  _saveCartId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(id) {
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", storage.setItem('cartId', id));

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _saveCartId.apply(this, arguments);
}

export function clearCartId() {
  return _clearCartId.apply(this, arguments);
}

function _clearCartId() {
  _clearCartId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt("return", storage.removeItem('cartId'));

          case 1:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _clearCartId.apply(this, arguments);
}

function retrieveImageCache() {
  return _retrieveImageCache.apply(this, arguments);
}

function _retrieveImageCache() {
  _retrieveImageCache = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            return _context10.abrupt("return", storage.getItem('imagesBySku') || {});

          case 1:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _retrieveImageCache.apply(this, arguments);
}

function saveImageCache(_x14) {
  return _saveImageCache.apply(this, arguments);
}

function _saveImageCache() {
  _saveImageCache = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(cache) {
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.abrupt("return", storage.setItem('imagesBySku', cache));

          case 1:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _saveImageCache.apply(this, arguments);
}

export function writeImageToCache() {
  return _writeImageToCache.apply(this, arguments);
} // Returns true if the cart is invalid.

function _writeImageToCache() {
  _writeImageToCache = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
    var item,
        media,
        sku,
        image,
        imageCache,
        _args12 = arguments;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            item = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : {};
            media = item.media_gallery_entries, sku = item.sku;

            if (!sku) {
              _context12.next = 12;
              break;
            }

            image = media && (media.find(function (m) {
              return m.position === 1;
            }) || media[0]);

            if (!image) {
              _context12.next = 12;
              break;
            }

            _context12.next = 7;
            return retrieveImageCache();

          case 7:
            imageCache = _context12.sent;

            if (!(imageCache[sku] !== image)) {
              _context12.next = 12;
              break;
            }

            imageCache[sku] = image;
            saveImageCache(imageCache);
            return _context12.abrupt("return", image);

          case 12:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _writeImageToCache.apply(this, arguments);
}

function isInvalidCart(error) {
  return !!(error.graphQLErrors && error.graphQLErrors.find(function (err) {
    return err.message.includes('Could not find a cart') || err.message.includes("The cart isn't active") || err.message.includes('The current user cannot perform operations on cart');
  }));
}